import PropTypes from 'prop-types';

import { useTheme } from '@mui/material/styles';

import AsyncTableContainer from '../Table/AsyncTableContainer';

import CheckmarkOrXComponent from '../Table/CheckmarkOrXComponent';

import { formatDate, isAdmin, isPM } from '../../utils';
import { getExportTitle } from '../ViewExport/utils';
import { getAnnouncementCriteria } from './utils';

import { TABLE_CONSTANTS, TABLE_ID } from '../Table/constants';

import { DATE_RANGES_TYPES, TABLE_DATA_TYPES } from '../../staticData';
import WithLink from '../Linkify';
import ListActions from '../Table/ListActions';
import { limitFilter } from '../Table/filters';
import AnnouncementsExport from './AnnouncementsExport';

const AnnouncementsListComponent = (props) => {
  const theme = useTheme();
  const {
    pmcId,
    buildingId,
    pmc,
    building,
    items,
    getItems,
    listKey,
    listParams,
    onDelete,
    onLoad,
    onAnnouncementsExport,
    openAnnouncementsModal,
    onSend,
    match,
  } = props;

  const columns = [
    {
      Header: 'Created at',
      id: 'created_at',
      accessor: ({ createdAt }) => formatDate(createdAt),
      headerClassName: 'sort',
    },
    {
      Header: 'Title',
      id: 'title',
      accessor: ({ subject }) => <WithLink>{subject}</WithLink>,
      sortable: false,
    },
    {
      Header: 'Message',
      id: 'message',
      accessor: ({ message }) => <WithLink>{message}</WithLink>,
      sortable: false,
    },
    {
      Header: 'Criteria',
      id: 'criteria',
      accessor: (entry) => (
        <div style={{ whiteSpace: 'pre-wrap' }}>
          {getAnnouncementCriteria(entry)}
        </div>
      ),
      sortable: false,
    },
    {
      Header: 'Is Sent?',
      id: 'sent',
      accessor: ({ sent }) => <CheckmarkOrXComponent value={sent} />,
      headerClassName: 'sort',
    },
    {
      Header: 'Actions',
      id: 'actions',
      fixed: 'right',
      accessor: (entry) => {
        const { id, sent } = entry;
        const action = [
          // {
          //   label: sent ? 'View' : 'View/Edit',
          //   isFullWidth: true,
          //   onClick: () => openAnnouncementsModal({ ...entry, isUpdate: true }),
          // },
          {
            label: 'Send',
            isFullWidth: true,
            onClick: () => onSend(id),
            color: theme.palette.success.main,
            show: !sent,
          },
          {
            label: 'Copy',
            isFullWidth: true,
            onClick: () => openAnnouncementsModal({ ...entry, isCopy: true }),
          },
          {
            label: 'Reject',
            isFullWidth: true,
            onClick: () => onDelete(id),
            color: theme.palette.secondary.main,
            show: !sent,
          },
        ];
        return <ListActions actions={action} isFullWidth />;
      },
      width: 120,
      sortable: false,
      show: isAdmin() || isPM(match?.params),
    },
  ];

  const filters = [limitFilter(listParams)];

  if (buildingId) {
    filters.splice(0, 1);
  }

  const action = [
    {
      label: '+ Create Pop-up Message',
      onClick: () => openAnnouncementsModal(),
      show: isAdmin() || isPM(match?.params),
    },
  ];

  const onRowClick = (rowInfo) => {
    const { original } = rowInfo;
    original && openAnnouncementsModal({ ...original, isUpdate: true });
  };

  const rowStyles = {
    style: {
      cursor: 'pointer',
    },
  };

  const defaultParams = {
    building: buildingId,
    pmc: pmcId,
    ordering: '-created_at',
  };

  const tableDataType = TABLE_DATA_TYPES.items;
  const title = `Pop-up messages`;

  const exportTitle = getExportTitle(title, pmc, building);
  const exportActions = (
    <AnnouncementsExport
      title={exportTitle}
      getDataForExport={onAnnouncementsExport}
      columns={columns}
    />
  );

  return (
    <AsyncTableContainer
      tableId={TABLE_ID.announcements}
      title={title}
      items={items}
      columns={columns}
      defaultSort={TABLE_CONSTANTS.created_at}
      defaultSortDesc
      manual
      filters={filters}
      onLoad={onLoad}
      getItems={getItems}
      listParams={listParams}
      defaultParams={defaultParams}
      tableDataType={tableDataType}
      listKey={listKey}
      action={<ListActions actions={action} />}
      dateRangeType={DATE_RANGES_TYPES.created_at}
      onRowClick={onRowClick}
      rowStyles={rowStyles}
      datePicker
      showFiltersAreApplied={false}
      exportActions={exportActions}
    />
  );
};

AnnouncementsListComponent.defaultProps = {
  pmcId: null,
  buildingId: null,
  pmc: null,
  building: null,
};

AnnouncementsListComponent.propTypes = {
  pmcId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  buildingId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  pmc: PropTypes.instanceOf(Object),
  building: PropTypes.instanceOf(Object),
  items: PropTypes.instanceOf(Object).isRequired,
  getItems: PropTypes.func.isRequired,
  listKey: PropTypes.string.isRequired,
  listParams: PropTypes.instanceOf(Object).isRequired,
  onLoad: PropTypes.func.isRequired,
  onSend: PropTypes.func.isRequired,
  openAnnouncementsModal: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onAnnouncementsExport: PropTypes.func.isRequired,
  match: PropTypes.instanceOf(Object).isRequired,
};

export default AnnouncementsListComponent;
